export function isUndefined(v: any): v is undefined {
  return typeof v === 'undefined';
}

export function isBoolean(v: any): v is boolean {
  return typeof v === 'boolean';
}

export function isFunction(v: any): v is Function {
  return typeof v === 'function';
}

export function isNumber(v: any): v is number {
  return typeof v === 'number';
}

export function isString(v: any): v is string {
  return typeof v === 'string';
}

export function isArray(v: any): v is any[] {
  return Array.isArray(v);
}
export function isObject(v: any): v is object {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

export function isUid(prefix: string, v: unknown): boolean {
  return isString(v) && v.startsWith(prefix) && v.length === 36 + prefix.length;
}

export function assertString(v: unknown): asserts v is string {
  if (typeof v !== 'string') throw new Error(`${v} is not a string`);
}

export function assertNumber(v: unknown): asserts v is number {
  if (typeof v !== 'number' || Number.isNaN(v)) throw new Error(`${v} is not a number or is NaN`);
}
